/**
 * Age is derived from birth month + year, never stored. A stored age goes stale
 * silently; a derived one is right on every app open. (Fortunaut's rule.)
 */
export function ageAt(dateOnly, { birthMonth, birthYear }) {
  const [year, month] = String(dateOnly).slice(0, 10).split('-').map(Number);
  let age = year - birthYear;
  if (month < birthMonth) age -= 1;
  return Math.max(0, age);
}
